import { Component } from '@angular/core';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    selector: 'rdx-login-callback',
    styleUrls: ['./login-callback.component.scss'],
    templateUrl: './login-callback.component.html',
})
export class LoginCallbackComponent {
    constructor(public userAuthService: UserAuthService) {}
}
